module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/trash-9fa61b0d9385f7fc6e102cbfbca20364.svg&quot;;"